// Phosis — Stamped reviews "Read more" toggle.
// Polls for the Stamped widget to finish rendering, then truncates long
// review bodies and adds an expand button per card.
(function () {
  var MAX_TRIES = 30;
  var tries = 0;

  function clampAndAddButtons() {
    var bodies = document.querySelectorAll('#stamped-main-widget .stamped-review-content-body');
    if (!bodies.length) return false;
    bodies.forEach(function (body) {
      if (body.dataset.phosisInit) return;
      body.dataset.phosisInit = '1';
      // Defer measurement to next frame to let layout settle
      requestAnimationFrame(function () {
        var isOverflowing = body.scrollHeight - body.clientHeight > 4;
        if (!isOverflowing) return;
        body.classList.add('is-clamped');
        var btn = document.createElement('button');
        btn.className = 'phosis-stamped-readmore';
        btn.type = 'button';
        btn.textContent = 'Read more';
        btn.addEventListener('click', function () {
          var open = body.classList.toggle('is-expanded');
          btn.textContent = open ? 'Show less' : 'Read more';
        });
        body.parentNode.insertBefore(btn, body.nextSibling);
      });
    });
    return true;
  }

  var iv = setInterval(function () {
    tries++;
    if (clampAndAddButtons() || tries >= MAX_TRIES) clearInterval(iv);
  }, 1000);

  // Also rerun after Stamped's load event
  document.addEventListener('stamped:reviews:load', clampAndAddButtons);
})();
